/**
 * 맵/트리 계층 선택 표시 — Array · String · Module
 */

function findTreeItemById(nodes, id) {
  for (const node of nodes || []) {
    if (node?.id === id) return node;
    const inChild = findTreeItemById(node.children, id);
    if (inChild) return inChild;
  }
  return null;
}

function findParentTreeItem(nodes, childId, parent = null) {
  for (const node of nodes || []) {
    if (node?.id === childId) return parent;
    const inChild = findParentTreeItem(node.children, childId, node);
    if (inChild) return inChild;
  }
  return null;
}

function displayLabelForNode(node) {
  if (!node) return null;
  return node.name || null;
}

/**
 * 트리 노드 → { array, string, module } 노드
 */
export function resolveHierarchyFromTreeItem(treeData, item) {
  if (!item?.type) {
    return { array: null, string: null, module: null };
  }
  if (item.type === 'array') {
    return { array: item, string: null, module: null };
  }
  if (item.type === 'string') {
    const array = findParentTreeItem(treeData, item.id);
    return { array, string: item, module: null };
  }
  if (item.type === 'module') {
    const string = findParentTreeItem(treeData, item.id);
    const array = string ? findParentTreeItem(treeData, string.id) : null;
    return { array, string, module: item };
  }
  return { array: null, string: null, module: null };
}

/**
 * 사이트 로드 후 기본 선택: 마지막 Array의 마지막 String (없으면 마지막 Array)
 */
export function findDefaultSelectionTreeItem(treeData) {
  const arrays = (treeData || []).filter(n => n?.type === 'array');
  if (!arrays.length) return null;

  const lastArray = arrays[arrays.length - 1];
  const strings = (lastArray.children || []).filter(n => n?.type === 'string');
  if (strings.length) {
    return strings[strings.length - 1];
  }
  return lastArray;
}

/**
 * sticky 바 표시용 라벨
 */
export function buildHierarchySelectionDisplay({
  treeData,
  activeTreeItem,
  stringDrawTargetArrayLabel,
  hasStringDrawTargetArray
}) {
  const hierarchy = resolveHierarchyFromTreeItem(treeData, activeTreeItem);

  return {
    arrayLabel: displayLabelForNode(hierarchy.array),
    stringLabel: displayLabelForNode(hierarchy.string),
    moduleLabel: displayLabelForNode(hierarchy.module),
    drawTargetLabel: hasStringDrawTargetArray ? stringDrawTargetArrayLabel : null
  };
}

export { findTreeItemById, findParentTreeItem };

function toArraySeqFromTreeNode(node) {
  if (node?.solarArraySeq != null) return Number(node.solarArraySeq);
  const match = String(node?.id || '').match(/^array_(\d+)$/);
  return match ? Number(match[1]) : null;
}

/** treeData에서 Array seq로 트리 노드 찾기 */
export function findArrayTreeItemBySeq(treeData, arraySeq) {
  if (arraySeq == null) return null;
  for (const node of treeData || []) {
    if (node?.type !== 'array') continue;
    const seq = toArraySeqFromTreeNode(node);
    if (seq != null && Number(seq) === Number(arraySeq)) {
      return node;
    }
  }
  return null;
}
